// extracted by mini-css-extract-plugin
export default {"root":"_3ehsR","left":"GpZAu","right":"_10OHW"};